"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var StackItem = function (_a) {
    var _b;
    var _c = _a.alignSelf, alignSelf = _c === void 0 ? 'auto' : _c, basis = _a.basis, className = _a.className, fill = _a.fill, grow = _a.grow, order = _a.order, shrink = _a.shrink, props = __rest(_a, ["alignSelf", "basis", "className", "fill", "grow", "order", "shrink"]);
    var AlignSelfClasses = {
        'auto': 'align-self-auto',
        'flex-start': 'align-self-start',
        'flex-end': 'align-self-end',
        'center': 'align-self-center',
        'baseline': 'align-self-baseline',
        'stretch': 'align-self-stretch',
    };
    var StackItemClass = classnames_1.default('StackItem', className, AlignSelfClasses[alignSelf], (_b = {
            'StackItem--fill': fill
        },
        _b["flex-grow-" + grow] = Number.isInteger(grow),
        _b["flex-shrink-" + shrink] = Number.isInteger(shrink),
        _b["order-" + order] = Number.isInteger(order),
        _b));
    var StackItemStyles = {
        flexBasis: basis,
    };
    return (react_1.default.createElement("div", __assign({ className: StackItemClass, style: StackItemStyles }, props)));
};
exports.StackItem = StackItem;
//# sourceMappingURL=StackItem.js.map